export const Style = {
  iError: `w-full border py-2 px-3 focus:outline-none text-sm 2xl:text-lg inputError rounded`,
  iInput: `w-full border border-gray-300 py-2 px-3 focus:outline-none focus:border-blue-500 rounded`,
  iInputDisable: `w-full border border-gray-100 py-2 px-3 focus:outline-none focus:border-blue-500 rounded`,
  label: `text-xs 2xl:text-base font-semibold text-gray-600 py-2`,
  iInputD: `w-full border border-gray-300 py-2 px-3 focus:outline-none focus:border-blue-500 rounded`,
};
